export const COUNTRY_CODES = [
    { code: '+503', label: 'El Salvador 🇸🇻', flag: '🇸🇻' },
    { code: '+502', label: 'Guatemala 🇬🇹', flag: '🇬🇹' },
    { code: '+504', label: 'Honduras 🇭🇳', flag: '🇭🇳' },
    { code: '+505', label: 'Nicaragua 🇳🇮', flag: '🇳🇮' },
    { code: '+506', label: 'Costa Rica 🇨🇷', flag: '🇨🇷' },
    { code: '+507', label: 'Panamá 🇵🇦', flag: '🇵🇦' },
    { code: '+1', label: 'USA/Canada 🇺🇸🇨🇦', flag: '🇺🇸' },
    { code: '+52', label: 'México 🇲🇽', flag: '🇲🇽' },
    { code: '+34', label: 'España 🇪🇸', flag: '🇪🇸' },
    { code: '+57', label: 'Colombia 🇨🇴', flag: '🇨🇴' },
    { code: '+54', label: 'Argentina 🇦🇷', flag: '🇦🇷' },
    { code: '+56', label: 'Chile 🇨🇱', flag: '🇨🇱' },
    { code: '+51', label: 'Perú 🇵🇪', flag: '🇵🇪' },
];

/**
 * Sanitizes a phone number by removing spaces, hyphens, and other non-digit characters.
 * Preserves the leading '+' if present.
 */
export const sanitizePhone = (phone: string, countryCode: string = ''): string => {
    // Remove all non-digits except the leading '+'
    let sanitized = phone.replace(/[^\d+]/g, '');

    // If it doesn't start with +, and we have a country code, prepend it
    if (!sanitized.startsWith('+') && countryCode) {
        sanitized = countryCode + sanitized;
    }

    return sanitized;
};

/**
 * Longitudes nacionales aceptadas por código de país. La clave sirve para
 * comparar teléfonos escritos con o sin código de país (+503 7777-1234 vs
 * 7777-1234) sin cambiar el valor guardado.
 */
const NATIONAL_LENGTHS: Record<string, number[]> = {
    '503': [8],
    '502': [8],
    '504': [8],
    '505': [8],
    '506': [8],
    '507': [8],
    '1': [10],
    '52': [10],
    '34': [9],
    '57': [10],
    '54': [10, 11],
    '56': [9],
    '51': [9],
};

/**
 * Devuelve solo los dígitos del número nacional, quitando prefijos
 * internacionales conocidos (00, +503, 503, +1, etc.).
 *
 * Ejemplos:
 *   +503 7777-1234 -> 77771234
 *   50377771234    -> 77771234
 *   7777-1234      -> 77771234
 */
export const normalizePhoneNationalKey = (phone: unknown): string => {
    let digits = String(phone ?? '').replace(/\D/g, '');
    if (!digits) return '';
    if (digits.startsWith('00')) digits = digits.slice(2);

    for (const [code, lengths] of Object.entries(NATIONAL_LENGTHS)) {
        const nationalLength = digits.length - code.length;
        if (digits.startsWith(code) && lengths.includes(nationalLength)) {
            return digits.slice(code.length);
        }
    }

    return digits;
};

/** Compara dos teléfonos ignorando formato y código de país. */
export const phonesMatch = (a: unknown, b: unknown): boolean => {
    const keyA = normalizePhoneNationalKey(a);
    const keyB = normalizePhoneNationalKey(b);
    return Boolean(keyA) && keyA === keyB;
};
